
import Vue from "vue";

export default Vue.extend({
  name: "component-place-category-icon",
  props: {
    iconName: String,
  },
});
